









import Vue, { PropType } from 'vue';
import { OrgRole } from '@/models';
import { OrgRoleFilter } from '@/orgRole';
import { orgRoleColors } from '@/components/utils/unrulrColors';

import RoleFilterPills, {
  RoleFilterOption
} from '@/components/RoleFilterPills.vue';

// A selected role takes the color of its chip on each member row, so the pill
// reads as that chip.
const activeClasses = (colors: string[]) => [
  ...colors,
  'grey--text',
  'text--darken-4'
];

export default Vue.extend({
  components: {
    RoleFilterPills
  },

  props: {
    value: {
      type: String as PropType<OrgRoleFilter>,
      default: 'ALL' as OrgRoleFilter
    },
    disabled: Boolean
  },

  computed: {
    options(): RoleFilterOption[] {
      return [
        {
          value: OrgRole.ADMIN,
          label: 'Admin',
          activeClasses: activeClasses(orgRoleColors.admin)
        },
        {
          value: OrgRole.ORGANIZER,
          label: 'Organizer',
          activeClasses: activeClasses(orgRoleColors.organizer)
        },
        {
          value: OrgRole.MEMBER,
          label: 'Member',
          activeClasses: activeClasses(orgRoleColors.member)
        }
      ];
    }
  },

  methods: {
    onChange(value: OrgRoleFilter) {
      this.$emit('change', value);
    }
  }
});
